import React from 'react';

export default function ArrowRightIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10" fill="none">
      <path
        d="M10.896 0.850483C10.6753 0.631795 10.3192 0.633384 10.1005 0.854032C9.88179 1.07468 9.88338 1.43083 10.104 1.64952L11.4263 2.96C11.9629 3.49185 12.331 3.85788 12.5801 4.16803C12.661 4.26882 12.7242 4.35755 12.7732 4.4375L1.5 4.4375C1.18934 4.4375 0.9375 4.68934 0.9375 5C0.9375 5.31066 1.18934 5.5625 1.5 5.5625L12.7732 5.5625C12.7242 5.64245 12.661 5.73118 12.5801 5.83197C12.331 6.14212 11.9629 6.50815 11.4263 7.04L10.104 8.35048C9.88338 8.56917 9.88179 8.92532 10.1005 9.14597C10.3192 9.36662 10.6753 9.36821 10.896 9.14952L12.242 7.81542C12.749 7.31297 13.1634 6.90231 13.4572 6.53641C13.7628 6.15591 13.984 5.76971 14.0431 5.30612C14.056 5.20449 14.0625 5.10224 14.0625 5C14.0625 4.89776 14.056 4.79551 14.0431 4.69388C13.984 4.23029 13.7628 3.84409 13.4572 3.4636C13.1634 3.09769 12.749 2.68703 12.242 2.18457L10.896 0.850483Z"
        fill="#5772FF"
      />
    </svg>
  );
}
